import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '@services/infra/config.service';

@Injectable({
  providedIn: 'root',
})
export class FreshdeskSupportService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly config: ConfigService,
  ) {}

  getTokenForSignedInUser() {
    const url = `${this.config.backendUrl}/v1/user/freshdesk-token`;
    return this.httpClient.get(url, {responseType: 'text'});
  }
}
